// O servidor manda dinheiro em CENTAVOS e o resto como número. Quem sabe qual é
// qual é o `measure_format` que vem junto do resultado, então a formatação mora
// aqui e não espalhada por cada widget.
const brl = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const integer = new Intl.NumberFormat('pt-BR');

export const formatMeasure = (value, format) => {
  if (format === 'currency') return brl.format((value || 0) / 100);
  if (format === 'percent') return `${(value || 0).toFixed(1)}%`;
  return integer.format(value || 0);
};

export const formatMoney = cents => brl.format((cents || 0) / 100);

export const formatInteger = value => integer.format(value || 0);

// Paleta fixa e na mesma ordem sempre: a fatia "Indicação" precisa ser da mesma
// cor hoje e amanhã, senão a comparação entre duas leituras do relatório engana.
export const PALETTE = [
  '#3b82f6',
  '#22c55e',
  '#f59e0b',
  '#ef4444',
  '#8b5cf6',
  '#06b6d4',
  '#ec4899',
  '#84cc16',
  '#f97316',
  '#6366f1',
  '#14b8a6',
  '#a855f7',
];

export const colorAt = index => PALETTE[index % PALETTE.length];
